import { render, staticRenderFns } from "./_SortDetail.vue?vue&type=template&id=3de1ff64&"
import script from "./_SortDetail.vue?vue&type=script&lang=js&"
export * from "./_SortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports